import validate from "/root/workspace/__flow_work/__flow_builds/d4099d0b-ea7f-40f7-9d4a-69741bb03d6e/workspace/soho-store-web_yhIy/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/root/workspace/__flow_work/__flow_builds/d4099d0b-ea7f-40f7-9d4a-69741bb03d6e/workspace/soho-store-web_yhIy/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}